<app-group
    [ngClass]="{'selected': (service.selectedNode$ | async).id == node.id}"
    (click)="service.setSelectedNode(node)"
    mat-ripple
    [node]="node"
    [showNavArrow]="showButton"
    [showBreadcrumbs]="true"></app-group>
<ng-template ngFor let-child [ngForOf]="node.children">
    <app-group-tree [showButton]="showButton" [node]="child"></app-group-tree>
</ng-template>